import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _appEnumsMap;
/**
 * 站点名称枚举
 *
 * @link https://miniprogram.alipay.com/docs/miniprogram/mpdev/api_alipay-connect_getsiteinfo
 */
export var SiteNameEnums;
(function (SiteNameEnums) {
  SiteNameEnums["EASYPAISA"] = "EASYPAISA";
  SiteNameEnums["TRUEMONEY"] = "TRUEMONEY";
  SiteNameEnums["KAKAOPAY"] = "KAKAOPAY";
  SiteNameEnums["BKASH"] = "BKASH";
  SiteNameEnums["ALIPAY_CN"] = "ALIPAY_CN";
  SiteNameEnums["ALIPAY_HK"] = "ALIPAY_HK";
  SiteNameEnums["ALIPAY_MO"] = "ALIPAY_MO";
  SiteNameEnums["GCASH"] = "GCASH";
  SiteNameEnums["TNG"] = "TNG";
  SiteNameEnums["DANA"] = "DANA";
})(SiteNameEnums || (SiteNameEnums = {}));
/**
 * 小程序容器 my.getSystemInfo 返回的 app 枚举
 *
 * @link https://miniprogram.alipay.com/docs/miniprogram/mpdev/api_device_system_getsysteminfo
 */
export var AppNameEnums;
(function (AppNameEnums) {
  AppNameEnums["alipayhk"] = "alipayhk";
  AppNameEnums["alipaymo"] = "alipaymo";
  AppNameEnums["gcash"] = "gcash";
  AppNameEnums["tngd"] = "tngd";
  AppNameEnums["dana"] = "dana";
  AppNameEnums["kakaopay"] = "kakaopay";
})(AppNameEnums || (AppNameEnums = {}));
export var appEnumsMap = (_appEnumsMap = {}, _defineProperty(_appEnumsMap, SiteNameEnums.ALIPAY_HK, AppNameEnums.alipayhk), _defineProperty(_appEnumsMap, SiteNameEnums.ALIPAY_MO, AppNameEnums.alipaymo), _defineProperty(_appEnumsMap, SiteNameEnums.GCASH, AppNameEnums.gcash), _defineProperty(_appEnumsMap, SiteNameEnums.DANA, AppNameEnums.dana), _defineProperty(_appEnumsMap, SiteNameEnums.TNG, AppNameEnums.tngd), _defineProperty(_appEnumsMap, SiteNameEnums.KAKAOPAY, AppNameEnums.kakaopay), _appEnumsMap);